import store from '../../store'

let role = 'manager'

export default {
  role,
  guard: () => store.getters['auth/isManager'],
  items: [
    {
      label: 'Carico Prodotti',
      name: `Warehouses`,
      items: []
    },
    {
      label: 'Firma',
      name: `Presence`,
      items: []
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/navigator/manager.js